import { useMemo } from 'react';
import { Box } from '@material-ui/core';
import { SText } from '@setvi/shared/components';
import {
  MatchIconV2,
  PointIconV2,
  TargetIconV2
} from '@setvi/shared/components/sicons';

import {
  AnalyticsColors,
  AnalyticsLabels
} from 'pages/auto-rfq/components/analytics';

export const AnalyticsIcons = {
  ExactMatch: (
    <TargetIconV2 fontSize="small" fill={AnalyticsColors.ExactMatch} />
  ),
  CloseMatch: (
    <PointIconV2 fontSize="small" fill={AnalyticsColors.CloseMatch} />
  ),
  PossibleMatch: (
    <MatchIconV2 fontSize="small" fill={AnalyticsColors.PossibleMatch} />
  )
};

const MatchIndicator = ({
  percentage,
  disabled,
  compact,
  fontSize = 12
}: {
  percentage: number;
  disabled?: boolean;
  compact?: boolean;
  fontSize?: number;
}) => {
  const currValue = useMemo(() => {
    if (percentage === 100) return 'ExactMatch';
    if (percentage >= 80) return 'CloseMatch';

    return 'PossibleMatch';
  }, [percentage]);

  return (
    <Box
      style={{
        width: 'fit-content',
        maxWidth: '100%',
        // Inline rows (the collapsed SKU line, tab previews) must not squeeze
        // the pill narrower than its label.
        flexShrink: 0,
        border: `0.5px solid ${disabled ? '#AFBAC6' : AnalyticsColors[currValue]}`,
        padding: compact ? '0px 8px' : '4px 8px',
        borderRadius: 16,
        display: 'flex',
        alignItems: 'center',
        background: disabled ? '#EEF0F2' : 'transparent',
        gap: 4
      }}>
      {/* AnalyticsIcons[currValue] */}
      {/* The label is a status, not content — it must always read in full.
          `noLineClamp` drops SText's default single-line clamp so the longest
          label ("Possible Match") wraps instead of ellipsizing when the badge
          is boxed in. */}
      <SText
        title={AnalyticsLabels[currValue]}
        fontColor={disabled ? '#AFBAC6' : AnalyticsColors[currValue]}
        weight="semibold"
        noLineClamp
        maxLines="unset"
        style={{
          fontWeight: 600,
          fontSize,
          whiteSpace: 'normal',
          wordBreak: 'normal',
          textAlign: 'center'
        }}
      />
    </Box>
  );
};

export default MatchIndicator;
